export default __webpack_public_path__ + "static/media/active.a3f965ca.svg";